
import { defineComponent, reactive, toRaw } from 'vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useVuelidate from '@vuelidate/core'
import { SignInValidation } from '@/modules/AuthModule/validations/SignIn.validation'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'restore'],
    setup(_, { emit }) {
        const state = reactive({
            login: null as string | null,
            password: null as string | null,
        })

        const v$ = useVuelidate(SignInValidation, state)

        const emitSubmit = () => {
            v$.value.$touch()
            if (v$.value.$invalid) return

            emit('submit', toRaw(state))
        }

        const emitRestore = () => {
            emit('restore')
        }

        return { state, v$, emitSubmit, emitRestore }
    },
})
